import { getOr } from 'lodash/fp';
import { call, put } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';
import * as Api from '../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../helpers/saga';
import {
  fetchInventoryLocationZones as fetchInventoryLocationZonesRoutine,
  createInventoryLocationZone as createInventoryLocationZoneRoutine,
  updateInventoryLocationZone as updateInventoryLocationZoneRoutine,
  deleteInventoryLocationZone as deleteInventoryLocationZoneRoutine
} from './routines';
import { removeZoneFromInventoryLocation } from '../../actions/location';

export const fetchInventoryLocationZones = ({ payload }) =>
  sagaRoutineRequest(fetchInventoryLocationZonesRoutine, {
    request: () =>
      call(Api.fetchInventoryLocationZones, { qs: getOr({}, 'qs', payload) })
  });

export const createInventoryLocationZone = ({ payload: body }) =>
  sagaRoutineRequest(createInventoryLocationZoneRoutine, {
    request: () => call(Api.createInventoryLocationZone, { body }),
    *success(response) {
      const { name } = body;
      yield toastr.success('Success', `created location zone "${name}"!`);
      return response;
    },
    *failure({ error, message }) {
      const { name } = body;
      const errDetails = getOr(message, '0.message', error);
      yield toastr.error(
        'Oops!',
        `Unable to create location zone "${name}". ${errDetails}`
      );
    }
  });

export const updateInventoryLocationZone = ({ payload: { id, body } }) =>
  sagaRoutineRequest(updateInventoryLocationZoneRoutine, {
    request: () => call(Api.updateInventoryLocationZone, { id, body }),
    *success() {
      const { name } = body;
      yield toastr.success('Success', `updated location zone to "${name}".`);
    }
  });

export const deleteInventoryLocationZone = ({
  payload: { name, id, inventoryLocationId }
}) =>
  sagaRoutineRequest(deleteInventoryLocationZoneRoutine, {
    request: () => call(Api.deleteInventoryLocationZone, id),
    successPayload: { id, inventoryLocationId },
    *success() {
      yield toastr.success('Success', `Deleted location zone "${name}".`);
      yield put(
        removeZoneFromInventoryLocation({ id: inventoryLocationId, zoneId: id })
      );
    }
  });
